
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[usernameOrId]/badges",
      function () {
        return require("private-next-pages/[usernameOrId]/badges.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[usernameOrId]/badges"])
      });
    }
  